/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { BundleType } from '../resources/nls/bundle';
import { FilePicker } from './FilePicker';
import { ComponentProps } from 'preact';
import { useComponentTheme } from '../hooks/UNSAFE_useComponentTheme';
import { FilePickerStyles } from './themes/FilePickerStyles.css';
import { FilePickerRedwoodTheme } from './themes/redwood/FilePickerTheme';
import { getPrimaryText, getSecondaryText } from './filePickerUtils';

type FilePickerProps = ComponentProps<typeof FilePicker>;

/**
 * Default content of the file picker
 */
export const FilePickerDefaultTriggerContent = ({
  isDisabled,
  primaryText,
  secondaryText,
  translations,
  selectionMode
}: Pick<FilePickerProps, 'isDisabled' | 'primaryText' | 'secondaryText' | 'selectionMode'> & {
  translations: BundleType;
}) => {
  const {
    styles: {
      disabledPrimaryTextStyle,
      primaryTextStyle,
      disabledSecondaryTextStyle,
      secondaryTextStyle
    }
  } = useComponentTheme<never, FilePickerStyles>(FilePickerRedwoodTheme);
  return (
    <>
      <div class={isDisabled ? disabledPrimaryTextStyle : primaryTextStyle}>
        {getPrimaryText(primaryText, translations)}
      </div>
      <div class={isDisabled ? disabledSecondaryTextStyle : secondaryTextStyle}>
        {getSecondaryText(secondaryText, translations, selectionMode)}
      </div>
    </>
  );
};
